"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var actions_1 = require("@shopify/app-bridge/actions");
var transformers_1 = require("../../utilities/transformers");
var context_1 = require("../../context");
/**
 * Modal component
 *
 * @remarks
 * React component which wraps the Shopify App Bridge Modal action.
 *
 * @public
 */
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focusReturnPoint = null;
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        var _a = this.props, open = _a.open, onClose = _a.onClose;
        var app = this.context;
        this.modal = actions_1.Modal.create(app, this.transformProps());
        if (onClose != null) {
            this.modal.subscribe(actions_1.Modal.Action.CLOSE, onClose);
        }
        if (open) {
            this.focusReturnPoint = document.activeElement;
            this.modal.dispatch(actions_1.Modal.Action.OPEN);
        }
    };
    Modal.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, open = _a.open, onClose = _a.onClose;
        var wasOpen = prevProps.open;
        var transformedProps = this.transformProps(wasOpen);
        this.modal.unsubscribe();
        if (isIframeModal(transformedProps)) {
            this.modal.set(transformedProps, open);
        }
        else {
            this.modal.set(transformedProps, open);
        }
        if (onClose != null) {
            this.modal.subscribe(actions_1.Modal.Action.CLOSE, onClose);
        }
        if (wasOpen !== open) {
            if (open) {
                this.modal.dispatch(actions_1.Modal.Action.OPEN);
            }
            else {
                this.modal.dispatch(actions_1.Modal.Action.CLOSE);
            }
        }
        if (!wasOpen && open) {
            this.focusReturnPoint = document.activeElement;
        }
        else if (wasOpen &&
            !open &&
            this.focusReturnPoint != null &&
            document.contains(this.focusReturnPoint)) {
            this.focusReturnPoint.focus();
            this.focusReturnPoint = null;
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        this.modal.unsubscribe();
        if (this.props.open) {
            this.modal.dispatch(actions_1.Modal.Action.CLOSE);
        }
    };
    Modal.prototype.render = function () {
        return null;
    };
    Modal.prototype.transformProps = function (wasOpen) {
        var _a = this.props, title = _a.title, size = _a.size, message = _a.message, src = _a.src, primaryAction = _a.primaryAction, secondaryActions = _a.secondaryActions, loading = _a.loading;
        var app = this.context;
        var safeSize = size == null ? undefined : actions_1.Modal.Size[size];
        var srcPayload = {};
        if (src != null) {
            if (src.match('^https?://')) {
                srcPayload.url = src;
            }
            else {
                srcPayload.path = src;
            }
        }
        return __assign(__assign({ title: title,
            message: message, size: safeSize }, srcPayload), { footer: {
                buttons: transformers_1.transformActions(app, {
                    primaryAction: primaryAction,
                    secondaryActions: secondaryActions,
                }),
            }, loading: wasOpen ? undefined : loading });
    };
    Modal.contextType = context_1.AppBridgeContext;
    return Modal;
}(react_1.default.PureComponent));
function isIframeModal(options) {
    return (typeof options.url === 'string' ||
        typeof options.path === 'string');
}
exports.default = Modal;
